import { Alert, Empty, Spin } from 'antd'
import type { ReactNode } from 'react'
import { Inbox } from 'lucide-react'

export function PageLoading({ tip }: { tip?: string }) {
  return (
    <div className="page-state page-state--loading">
      <Spin size="large" tip={tip} />
    </div>
  )
}

export function PageError({
  message,
  description,
}: {
  message?: string
  description?: ReactNode
}) {
  return (
    <Alert
      type="error"
      showIcon
      message={message || 'Something went wrong'}
      description={description}
    />
  )
}

export function PageEmpty({
  description,
  icon,
  children,
}: {
  description: ReactNode
  icon?: ReactNode
  children?: ReactNode
}) {
  return (
    <div className="page-state page-state--empty">
      {icon ?? <Inbox size={28} className="text-primary opacity-80" />}
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} className="!m-0" />
      {children}
    </div>
  )
}
